import { render, staticRenderFns } from "./PromotionDiscountDescriptionDappForm.vue?vue&type=template&id=1bc002a8&"
import script from "./PromotionDiscountDescriptionDappForm.vue?vue&type=script&lang=js&"
export * from "./PromotionDiscountDescriptionDappForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports